export default {
	getTaskList: '/tasks/list', //新增账户
	getTaskDetail: '/tasks/', // 获取任务详情
	getSubTaskList: '/tasks/', // 子任务列表
	editTaskDetail: '/tasks/', // 修改任务
	getTaskGroup: '/tasks/groups/list',
	getTaskFlowList: '/tasks/flows',
	addFile: '/tasks/files',
	removeFile: '/tasks/files',
	taskbanList: '/tasks/boards/list', //任务看板
	getStaff: '/tasks/statistics/staff', //人员统计
	getStatistics: '/tasks/statistics', //任务统计
	getOrder: '/tasks/statistics/orders', //订单统计
	previewInform: '/tasks/rules/trigger/preview_list', //预览通知
	batchAppoint: '/tasks/batch/appoint', // 批量设置服务人员
};
